import { BaasicDropdownStore, BaseEditViewStore } from 'core/stores';
import DxCodeDropdownStore from 'application/facility-order-new-flow-us-intake/stores/DxCodeDropdownStore';
import { FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { PatientService } from "application/patient/services";
import { ClinicalStatusService } from 'application/clinical-status/services';
import { LocalDoctorService } from 'application/import/services';
import { DiagnosisCodeService } from "application/import/services";
import { MissingDocumentService } from 'application/missing-document/services';
import { action, observable } from "mobx";
import { ModalParams } from 'core/models';
import _ from 'lodash';

class FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore extends BaseEditViewStore {
    @observable accessor loadingData = false;
    @observable accessor isSyncInProgress = false;
    @observable accessor facilityOrderTemplate;
    @observable accessor patient;
    @observable accessor missingDocsPreviousValue;
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const patientService = new PatientService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplate = componentProps.modalParams.data.facilityOrderTemplate;
        const patient = componentProps.modalParams.data.patient;
        const isUSIntakeNewFlow = componentProps.modalParams.data.isUSIntakeNewFlow;

        super(rootStore, {
            name: 'facility-order-template-us-intake-clinical-information-modal',
            Form: FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalForm,
            id: facilityOrderTemplate && facilityOrderTemplate.id,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                        const fresh = await patientService.get(patient.patientKey);
                        const patientData = fresh && fresh.data && fresh.data.patientClinicalInfo;

                        patient.height = patientData.height;
                        patient.weight = patientData.weight;
                        
                        return {
                            ...facilityOrderTemplate,
                            facilityOrderTemplateMissingDocuments: facilityOrderTemplate.facilityOrderTemplateMissingDocuments && facilityOrderTemplate.facilityOrderTemplateMissingDocuments.map(i => ({ ...i.missingDocument, facilityOrderTemplateMissingDocumentId: i.id, note: i.note })),
                            height: patient.height,
                            weight: patient.weight
                        };
                    },
                    update: async (resource) => {
                        resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id, note: i.note } });
                        if (isUSIntakeNewFlow) {
                            const response = await facilityOrderTemplateService.updateNewFlowUSIntakeTemplate({ ...facilityOrderTemplate, facilityOrderTemplateItems: facilityOrderTemplate.facilityOrderTemplateItems.filter((i) => i.product), ...resource });
                            return response.data;
                        }
                        else {
                            const response = await facilityOrderTemplateService.updateNewFlowClinicalTemplate({ ...facilityOrderTemplate, facilityOrderTemplateItems: facilityOrderTemplate.facilityOrderTemplateItems.filter((i) => i.product), ...resource });
                            return response.data;
                        }
                    },
                    updatePatientDetails: async (resource) => {
                        const response = await patientService.updatePatientDetails(resource);
                        return response;
                    },
                }
            },
            FormClass: FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalForm,
            autoInit: false
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.setDifferentQty = componentProps.modalParams.data.setDifferentQty;
        this.facilityOrderTemplate = facilityOrderTemplate;
        this.missingDocsPreviousValue = this.getMissingDocsPreviousValue();
        this.isEligible = componentProps.modalParams.data.isEligible;
        this.patient = patient;
        this.facilityOrderPatient = componentProps.modalParams.data.facilityOrderPatient;
        this.isUSIntakeNewFlow = isUSIntakeNewFlow;
        this.lookups = this.modalParams.data.lookups;
        this.disabled =  this.modalParams.data.disabled;
        this.service = facilityOrderTemplateService;
        this.clinicalStatusService = new ClinicalStatusService(rootStore.application.baasic.apiClient);
        this.diagnosisCodeService = new DiagnosisCodeService(rootStore.application.baasic.apiClient);
        this.localDoctorService = new LocalDoctorService(rootStore.application.baasic.apiClient);
        this.missingDocumentService = new MissingDocumentService(rootStore.application.baasic.apiClient);
        this.patientService = patientService;

        this.facilityOrder = componentProps.modalParams.data.facilityOrder;
        this.isMasterPatient = this.patient.patientKey ? (this.facilityOrder && this.facilityOrder.facility.masterPatientId == this.patient.patientKey) : false;
        this.setIsQtyChange = componentProps.modalParams.data.setIsQtyChange;

        this.clinicalStatusStore = new BaasicDropdownStore({}, {
            fetchFunc: async () => {
                const response = await this.clinicalStatusService.find({ rpp: 50, isMasterPatient: this.isMasterPatient });
                this.clinicalStatuses = response.data.item;
                return this.clinicalStatuses;
            }
        });

        this.doctorStore = new BaasicDropdownStore({
            textField: 'orderingDoctor',
            filterable: true,
            returnObject: true,
            initFetch: false,
        }, {
            fetchFunc: async (term) => {
                const response = await this.localDoctorService.find({ searchQuery: term, rpp: 20 });

                _.extend(response.data,
                    {
                        item: _.map(response.data.item, (item => {
                            return _.extend(
                                item, {
                                orderingDoctor: item.name + " - " + item.npi,
                            }
                            );
                        }))
                    }
                );

                return response.data.item;
            }
        });

        this.missingDocumentStore = new BaasicDropdownStore({ multi: true, filterable: true }, {
            fetchFunc: async (term) => {
                const response = await this.missingDocumentService.find({ searchQuery: term, rpp: 100, isActive: true, sort: 'name|asc', itemCategoryId: this.facilityOrderTemplate.itemCategoryId });
                return this.filterMissingDocumentStore(response.data.item);
            }
        });

        this.dxCode1Store = this.createDxCodeDropdownStore("dxCode1");
        this.dxCode2Store = this.createDxCodeDropdownStore("dxCode2");
        this.dxCode3Store = this.createDxCodeDropdownStore("dxCode3");
        this.dxCode4Store = this.createDxCodeDropdownStore("dxCode4");
        this.dxCode5Store = this.createDxCodeDropdownStore("dxCode5");
        this.dxCode6Store = this.createDxCodeDropdownStore("dxCode6");
        this.dxCode7Store = this.createDxCodeDropdownStore("dxCode7");
        this.dxCode8Store = this.createDxCodeDropdownStore("dxCode8");

        this.facilityOrderTemplateMissingDocumentNoteModal = new ModalParams({ onClose: null });
        this.facilityOrderTemplatePNMissingInformationModal = new ModalParams({ onClose: null });
        this.facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal = new ModalParams({});

        this.setInactiveReasons = this.modalParams.data.setInactiveReasons;
        this.fetch([
            this.initialize()
        ]);
    }

    @action.bound
    createDxCodeDropdownStore() {
        return new DxCodeDropdownStore(
            { filterable: true, dataItemKey: "code", textField: "code" },
            {
                fetchFunc: async (term) => {
                    if (!term || term.trim() === '') {
                        term = undefined;
                    }

                    const response = await this.diagnosisCodeService.find({ searchQuery: term, rpp: 10, itemCategoryId: this.facilityOrderTemplate && this.facilityOrderTemplate.itemCategoryId, isBillable: true });
                    return response.data.item;
                }
            }
        );
    }

    @action
    async initialize() {
        this.loadingData = true;
        if (this.isEdit) {
            if (this.isUSIntakeNewFlow) {
                await this.initializeData();
            }
           
            await this.getResource(this.id);
            await this.doctorStore.filterAsync(this.facilityOrderTemplate.orderingDoctor && this.facilityOrderTemplate.orderingDoctor.npi);

            if (!this.facilityOrderTemplate.clinicalStatusId) {
                this.clinicalStatusStore.setValue({ id: null, name: "Select" });
            }
            this.missingDocsPreviousValue = this.getMissingDocsPreviousValue();
        } else {
            this.form.clear();
        }
        this.loadingData = false;
    }

    @action
    async setItem(item) {
        this.item = item;
        this.itemInitialized = true;
        await this.setDefaultStoreValue(item);
    }

    @action.bound
    async setDefaultStoreValue(data) {
        const codes = [data.dxCode1, data.dxCode2, data.dxCode3, data.dxCode4, data.dxCode5, data.dxCode6, data.dxCode7, data.dxCode8];
        const resolved = await Promise.all(codes.map(async (code) => {
            if (!code) return null;
            const response = await this.diagnosisCodeService.find({ searchQuery: code, rpp: 10, itemCategoryId: this.facilityOrderTemplate && this.facilityOrderTemplate.itemCategoryId, isBillable: true });
            const match = response.data.item && response.data.item.find(x => x.code === code);
            return match || { code };
        }));
        for (let i = 0; i < resolved.length; i++) {
            this[`dxCode${i + 1}Store`].setValue(resolved[i]);
        }
    }

    @action.bound
    async initializeData() {
        let params = {
            embed: 'FacilityOrderTemplateInitial,FacilityOrderTemplateInitial.OrderingDoctor,FacilityOrderTemplateInitial.ClinicalStatus,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor',
            fields: 'dxCode1,dxCode2,dxCode3,dxCode4,dxCode5,dxCode6,dxCode7,dxCode8,note,swo,FacilityOrderTemplateInitial,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateMissingDocumentInitials,OrderingDoctor,clinicalStatusId'
        }
        const template = (await this.service.get(this.facilityOrderTemplate.id, params)).data;

        if (this.facilityOrderTemplate.facilityOrderTemplateInitial && template.facilityOrderTemplateInitial) {
            this.facilityOrderTemplate.facilityOrderTemplateInitial.clinicalStatusId = template.facilityOrderTemplateInitial.clinicalStatusId;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.clinicalStatus = template.facilityOrderTemplateInitial.clinicalStatus;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode1 = template.facilityOrderTemplateInitial.dxCode1;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode2 = template.facilityOrderTemplateInitial.dxCode2;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode3 = template.facilityOrderTemplateInitial.dxCode3;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode4 = template.facilityOrderTemplateInitial.dxCode4;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode5 = template.facilityOrderTemplateInitial.dxCode5;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode6 = template.facilityOrderTemplateInitial.dxCode6;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode7 = template.facilityOrderTemplateInitial.dxCode7;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.dxCode8 = template.facilityOrderTemplateInitial.dxCode8;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.note = template.facilityOrderTemplateInitial.note;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.swo = template.facilityOrderTemplateInitial.swo;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.orderingDoctorId = template.facilityOrderTemplateInitial.orderingDoctorId;
            this.facilityOrderTemplate.facilityOrderTemplateInitial.orderingDoctor = template.facilityOrderTemplateInitial.orderingDoctor;
        }

        this.facilityOrderTemplate.orderingDoctor = template.orderingDoctor;
        this.facilityOrderTemplate.orderingDoctorId = template.orderingDoctor && template.orderingDoctor.id;
        this.facilityOrderTemplate.note = template.note;
        this.facilityOrderTemplate.swo = template.swo;
        this.facilityOrderTemplate.dxCode1 = template.dxCode1;
        this.facilityOrderTemplate.dxCode2 = template.dxCode2;
        this.facilityOrderTemplate.dxCode3 = template.dxCode3;
        this.facilityOrderTemplate.dxCode4 = template.dxCode4;
        this.facilityOrderTemplate.dxCode5 = template.dxCode5;
        this.facilityOrderTemplate.dxCode6 = template.dxCode6;
        this.facilityOrderTemplate.dxCode7 = template.dxCode7;
        this.facilityOrderTemplate.dxCode8 = template.dxCode8;
        this.facilityOrderTemplate.facilityOrderTemplateMissingDocumentInitials = template.facilityOrderTemplateMissingDocumentInitials;
        this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments = template.facilityOrderTemplateMissingDocuments;
        this.facilityOrderTemplate.clinicalStatusId = template.clinicalStatusId
    }

    @action.bound
    openFacilityOrderTemplateMissingDocumentNoteModal(missingDocument) {
        this.facilityOrderTemplateMissingDocumentNoteModal.open({
            missingDocument: _.extend(missingDocument, { facilityOrderTemplateId: this.facilityOrderTemplate.id })
        });
    }

    @action.bound
    async updateResource(resource, generateDocuments = false) {
        if (!this.actions.update) return;

        if (generateDocuments && !this.form.isDirty) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            if (resource.height != this.height || resource.weight != this.weight) {
                await this.actions.updatePatientDetails({
                    patientBrightreeId: this.patient.patientKey,
                    height: resource.height,
                    weight: resource.weight,
                    ssn: this.patient.ssn
                });

                this.patient.height = resource.height;
                this.patient.weight = resource.weight;
            }

            const isPartialUpdate = this.facilityOrderTemplate.clinicalStatusId == resource.clinicalStatusId;
            if (!isPartialUpdate) {
                var clinicalStatus = this.clinicalStatuses.find(x => x.id == resource.clinicalStatusId);
                var oldClinicalStatus = this.clinicalStatuses.find(x => x.id == this.facilityOrderTemplate.clinicalStatusId);

                if ((clinicalStatus && (clinicalStatus.name == "Covered" || clinicalStatus.name == "Prior Auth Obtained")) &&
                    !(oldClinicalStatus && (oldClinicalStatus.name == "Covered" || oldClinicalStatus.name == "Prior Auth Obtained")) &&
                    (await this.service.isIVPoleItemNeeded({ id: this.facilityOrderTemplate.id, isReferenceBillable: true })).data) {
                    this.rootStore.notificationStore.warning("Checking for IV pole.");
                }
            }

            var response = await this.actions.update({
                id: this.id,
                isPartialUpdate: isPartialUpdate,
                ...resource
            });

            this.facilityOrderTemplate.clinicalStatusId = response.clinicalStatusId;
            this.facilityOrderTemplate.note = response.note;
            this.facilityOrderTemplate.swo = response.swo;
            this.facilityOrderTemplate.dxCode1 = response.dxCode1;
            this.facilityOrderTemplate.dxCode2 = response.dxCode2;
            this.facilityOrderTemplate.dxCode3 = response.dxCode3;
            this.facilityOrderTemplate.dxCode4 = response.dxCode4;
            this.facilityOrderTemplate.dxCode5 = response.dxCode5;
            this.facilityOrderTemplate.dxCode6 = response.dxCode6;
            this.facilityOrderTemplate.dxCode7 = response.dxCode7;
            this.facilityOrderTemplate.dxCode8 = response.dxCode8;
            this.facilityOrderTemplate.orderingDoctorId = response.orderingDoctorId;
            this.facilityOrderTemplate.clinicalStatusNote = response.clinicalStatusNote;
            this.facilityOrderTemplate.newFlowStatusId = response.newFlowStatusId;
            this.facilityOrderTemplate.newFlowUSIntakeStatusId = response.newFlowUSIntakeStatusId;
            this.facilityOrderTemplate.clinicalStatus = response.clinicalStatus;

            if (!this.isUSIntakeNewFlow) {
                this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments = response.facilityOrderTemplateMissingDocuments;
                this.facilityOrderTemplate.orderingDoctor = response.orderingDoctor;
                this.facilityOrderTemplate.newFlowStatus = response.newFlowStatus;
                this.facilityOrderTemplate.newFlowUSIntakeStatus = response.newFlowUSIntakeStatus;
            }

            if (!isPartialUpdate) {
                this.facilityOrderTemplate.facilityOrderTemplateItems = response.facilityOrderTemplateItems;
                if (response.inactiveReasonId == 16) {
                    this.facilityOrderTemplate.isDoNotSupply = true;
                }
                this.facilityOrderTemplate.inactiveReasonId = response.inactiveReasonId;
                this.setDifferentQty();
            }

            this.showChangeTriangels();
            this.setIsQtyChange();

            this.form.setFieldsDisabled(false);

            if (!generateDocuments) {
                await this.modalParams.close();
            }
            this.missingDocsPreviousValue = this.getMissingDocsPreviousValue();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async generateStandardWrittenOrder(updateResource = true) {
        try {
            if (updateResource) {
                await this.updateResource(this.form.values(), true);
            }
            var url = `${this.service.getStandardWrittenOrderReportUrl(this.facilityOrderTemplate.id)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
            window.open(url, "_blank")
            this.rootStore.notificationStore.success("Standard Written Order successfully generated.");
        }
        catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to generate Standard Written Order.");
        }
    }
    getMissingInformationUrological() {
        return this.facilityOrderTemplate.facilityOrderTemplateItems.some(x =>
            (
                (x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4352")) ||
                (x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4353")) ||
                (x.product && x.product.procedureCode_ && (x.product.procedureCode_.abrv === "A4351"))
            ) &&
            ((!x.templateQuantity) || (x.templateQuantity == 0) || (x.templateQuantity % 28 != 0))
        );
    }

    @action.bound
    async generateMedicalNecessityForm() {
        try {
            await this.updateResource(this.form.values(), true);
            if (this.facilityOrderTemplate.itemCategoryId === this.lookups.itemCategory.find(y => y.abrv == 'enteral').id && this.getMissingInformationText()) {
                this.facilityOrderTemplatePNMissingInformationModal.open({
                    missingInformation: this.getMissingInformationText(),
                    generateMedicalNecessityForm: () => this.openMedicalNecessityWindow()
                });
            }
            else if (this.facilityOrderTemplate.itemCategoryId === this.lookups.itemCategory.find(y => y.abrv == 'urological').id && this.getMissingInformationUrological()) {
                this.facilityOrderTemplatePNMissingInformationModal.open({
                    missingInformation: ["Qty per day (system cannot determine)"],
                    generateMedicalNecessityForm: () => this.openMedicalNecessityWindow()
                });
            }
            else {
                await this.openMedicalNecessityWindow();
            }
        }
        catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to generate Medical Necessity Form.");
        }
    }

    @action.bound
    async openMedicalNecessityWindow() {
        var url = `${this.service.getMedicalNecessityFormReportUrl(this.facilityOrderTemplate.id)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(url, "_blank")
        this.rootStore.notificationStore.success("Progress Notes document successfully generated.");
    }

    getMissingInformationText() {
        let isPatientWeightMissing = this.patient && !this.patient.weight;
        let isPatientHeightMissing = this.patient && !this.patient.height;
        let isCalorieAmountMissing = this.facilityOrderTemplate.facilityOrderTemplateItems.some(x => x.product && x.product.itemTypeId && !x.itemCals && x.importActionId != this.lookups.importAction.find(y => y.abrv == 'delete').id);
        let isPatientGenderMissing = this.patient && !this.patient.gender;
        let isMlphMissing = this.facilityOrderTemplate.facilityOrderTemplateItems.some(x => x.product && x.product.itemTypeId && !x.mlph && x.importActionId != this.lookups.importAction.find(y => y.abrv == 'delete').id);

        let missingItems = [];
        if (isPatientWeightMissing) {
            missingItems.push("weight");
        }
        if (isPatientHeightMissing) {
            missingItems.push("height");
        }
        if (isCalorieAmountMissing) {
            missingItems.push("total calories");
        }
        if (isPatientGenderMissing) {
            missingItems.push("gender");
        }
        if (isMlphMissing) {
            missingItems.push("flow rate");
        }
        missingItems.sort();

        if (missingItems.length > 0)
            return missingItems;
        return null;
    }

    filterMissingDocumentStore(missingDocuments) {
        let result = missingDocuments;
        if (missingDocuments && missingDocuments.some(m => m)) {
            let facilityOrderTemplateItems = this.facilityOrderTemplate && this.facilityOrderTemplate.facilityOrderTemplateItems;

            const deleteImportActionId = this.lookups.importAction.find(x => x.abrv === 'delete').id;

            const diabeticFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "diabetic-formula").id;
            const renalFormulaNeproNRSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "renal-formula-nepro-nr").id;
            const renalFormulaSuplenaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "renal-formula-suplena").id;
            const pulmonaryFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "pulmonary-formula").id;
            const elementalFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "elemental-formula").id;
            const proteinSupplementSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "protein-supplement").id;
            const siliconeCatheterSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "silicone-catheter").id;
            const coudeCatheterSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "coude-catheter").id;

            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == diabeticFormulaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-diabetic");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaNeproNRSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-renal-nepro");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaSuplenaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-renal-suplena");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == pulmonaryFormulaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-pulmonary");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == elementalFormulaSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-elemental");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == proteinSupplementSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-protein-supplement");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == siliconeCatheterSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-silicone-catheter");
            }
            if (!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == coudeCatheterSpecialtyTypeId))) {
                result = result.filter(i => i.abrv !== "specialty-product-justification-coude-catheter");
            }
        }
        return result;
    }

    @action.bound
    async syncOrderingDoctors() {
        if (this.isSyncInProgress)
            return;

        this.isSyncInProgress = true;
        try {
            await this.localDoctorService.sync();
            this.rootStore.notificationStore.success("Sync Ordering Doctors successfully done.");
        } catch (err) {
            this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to sync ordering doctors.');
        }
        this.isSyncInProgress = false;
    }

    @action.bound
    async generateMedicalNecessityFormAndStandardWrittenOrder() {
        await this.generateMedicalNecessityForm();
        await this.generateStandardWrittenOrder(false);
    }

    @action.bound
    onHeightWeightFocus(e) {
        e.target.select();
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal() {
        this.facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal.open({
            facilityOrderTemplate: this.facilityOrderTemplate
        });
    }

    @action.bound
    getMissingDocsPreviousValue() {
        if (!this.facilityOrderTemplate.facilityOrderTemplateMissingDocumentInitials || !this.facilityOrderTemplate.facilityOrderTemplateMissingDocumentInitials.some(x => x)) {
            return (!this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments || !this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments.some(x => x)) ? null : "";
        }

        let missingDocuments = _.sortBy(this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments, md => md.missingDocument.name);
        let missingDocumentInitials = _.sortBy(this.facilityOrderTemplate.facilityOrderTemplateMissingDocumentInitials, mdi => mdi.missingDocument.name);

        if (missingDocuments.map(mdi => mdi.missingDocument.name).join(", ") != missingDocumentInitials.map(mdi => mdi.missingDocument.name).join(", ")) {
            return missingDocumentInitials.map(mdi => mdi.missingDocument.name).join(", ");
        }
        return null;
    }

    showChangeTriangels() {
        _.forEach(this.facilityOrderTemplate.facilityOrderTemplateItems, (facilityOrderTemplateItem) => {
            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.templateQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.templateQuantity) {
                if (!facilityOrderTemplateItem.isTemplateQuantityChanged) {
                    facilityOrderTemplateItem.isTemplateQuantityChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isTemplateQuantityChanged = false;

            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.orderQuantity != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.orderQuantity) {
                if (!facilityOrderTemplateItem.isOrderQuantityChanged) {
                    facilityOrderTemplateItem.isOrderQuantityChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isOrderQuantityChanged = false;

            if (facilityOrderTemplateItem.facilityOrderTemplateItemInitial && facilityOrderTemplateItem.note != facilityOrderTemplateItem.facilityOrderTemplateItemInitial.note) {
                if (!facilityOrderTemplateItem.isNoteChanged) {
                    facilityOrderTemplateItem.isNoteChanged = true;
                }
            }
            else
                facilityOrderTemplateItem.isNoteChanged = false;
        });
        this.isQtyChange = true;
        this.isQtyChange = false;
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore;
